import React, { useEffect, useState } from "react";
import styles from "./Content.module.css"
import Header from "../../components/Header";
import CategoryTabs from "../../components/content/CategoryTabs";
import { useNavigate, useSearchParams } from "react-router-dom";
import { KOR_TO_CATEGORY, CATEGORY_TO_KOR } from "../../util/mapping";
import { useReportList } from "../../hooks/useReportList";
import Spinner from '../../components/util/Spinner';
import { CATEGORY_DESCRIPTION, KorCategory } from "../../constants/reportCategoryDescription";
import { formatDate } from "../../util/formatDate";
import '../../styles/global.css'
import ContentManageCard from "../../components/content/ContentManageCard";
import pencilIcon from '../../assets/image/pencilIcon.svg';

const ContentManagePage: React.FC = () => {
    const navigation = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [windowHeight, setWindowHeight] = useState(window.innerHeight);
    const initialCategory = (searchParams.get("category") as KorCategory) ?? "전체";
    const [activeCategory, setActiveCategory] = useState<KorCategory>(initialCategory);

    const serverCategory = KOR_TO_CATEGORY[activeCategory];
    const { title, sub } = CATEGORY_DESCRIPTION[activeCategory];
    
    const { data, isLoading, isError } = useReportList({
      category: serverCategory,
      cursor: null,
      size: 20,
    });

    useEffect(() => {
      setSearchParams({ category: activeCategory }, { replace: true });
    }, [activeCategory, setSearchParams]);

    useEffect(() => {
        const isAdmin = sessionStorage.getItem("isAdmin");
        if (!isAdmin) {
            alert("관리자만 접근 가능합니다");
            navigation("/admin/login");
        }
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setWindowHeight(window.visualViewport?.height || window.innerHeight);
        };

        window.addEventListener('resize', handleResize);
        
        // 초기 로드 시 한 번 실행
        handleResize();

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleBack = () => {
        navigation(-1);
    };

    const handleToWrite = () => {
        navigation("/admin/content/write?from=write");
    }

    

    const reportList = data?.reportList ?? [];

    return (         
        <div className={styles.content} style={{ minHeight: `${windowHeight}px`, display: "flex", flexDirection: "column" }}>
            <div className={styles.container}>
                <Header type="title" title="찐빵 리포트 목록 관리" onClick={handleBack}/>
                <div className={styles.section}>
                    <CategoryTabs active={activeCategory} onChange={setActiveCategory} />
                    <div className={styles.categoryInfo}>
                        <p className={styles.infoTitle}>{title}</p>
                        <p className={styles.infoSub}>{sub}</p>
                    </div>
                    {isLoading && <div style={{
                        margin: '0 auto',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '50vh',
                        }}>
                        <Spinner />
                    </div>
                    }
                    {!isLoading && !isError && (
                      <div className={styles.contentWrap}>
                        {reportList.map(item => (
                          <ContentManageCard
                            key={item.id}
                            id={item.id}
                            category={CATEGORY_TO_KOR[item.category]}
                            title={item.title}
                            date={formatDate(item.createdAt)}
                            likes={item.likeCount}
                            views={item.viewCount}
                          />
                        ))}
                      </div>
                    )}
                </div>
                <button className={styles.writeBtn} onClick={handleToWrite}>
                    <img src={pencilIcon} alt="write" className={styles.writeImg}/>
                </button>
            </div>
        </div>
    );
}

export default ContentManagePage;